import { Button, Stack, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import {
  useChangeCategoryMutation,
  useListItemDetailsQuery,
} from 'api/ml-service/ml-service';
import ClientPaginationDataGrid from 'components/client-pagination-data-grid/client-pagination-data-grid.component';
import IncQuickFilterToolbar from 'components/inc-quick-filter-toolbar/inc-quick-filter-toolbar.component';
import { useTranslation } from 'react-i18next';
import ItemClassifierGridAutocomplete from './item-classifier-grid-autocomplete/item-classifier-grid-autocomplete.component';
import { Edit } from '@mui/icons-material';

const ItemClassifier = () => {
  const { t } = useTranslation();
  const { data, isFetching } = useListItemDetailsQuery(null);
  const [changeCategory, { isLoading: changeCategoryLoading }] =
    useChangeCategoryMutation();

  const columns: GridColDef[] = [
    {
      field: 'itemName',
      headerName: t('page.menus.recommendations.dataGrid.columns.itemName'),
      minWidth: 300,
      hideable: false,
    },
    {
      field: 'category',
      headerName: t(
        'page.menus.recommendations.dataGrid.columns.categoryGroup',
      ),
      minWidth: 200,
      renderCell: params => params.value?.toUpperCase(),
    },
    {
      field: 'subCategory',
      headerName: t('page.menus.recommendations.dataGrid.columns.subCategory'),
      minWidth: 200,
      editable: true,
      renderCell: params => (
        <Button
          variant="text"
          data-testid="ItemClassifier.Button"
          startIcon={<Edit />}
          onClick={() => {
            params.api.startCellEditMode({
              id: params.id,
              field: params.field,
            });
          }}
        >
          {params.value?.toUpperCase()}
        </Button>
      ),
      renderEditCell: params => (
        <ItemClassifierGridAutocomplete
          {...params}
          changeCategory={changeCategory}
        />
      ),
    },
  ];

  return (
    <Stack marginTop={2}>
      <Typography variant="subtitle2">
        {t('page.menus.recommendations.itemClassifier.subtitle')}
      </Typography>
      <ClientPaginationDataGrid
        columns={columns}
        rows={data?.itemDetails ?? []}
        slots={{ toolbar: IncQuickFilterToolbar }}
        getRowId={row => row.itemId}
        isLoading={isFetching || changeCategoryLoading}
      />
    </Stack>
  );
};

export default ItemClassifier;
